export const abbrevName = (name, truncateAfterNum) => {
  if (!name) return name
  const nameParts = name.split(" ")
  
  if (nameParts.length <= 1) return name
  let newName = `${nameParts[0].charAt(0)}. `

  nameParts.forEach((p,i) => {
    if (i === 0) return

    newName += `${p} `
  })

  newName = newName.slice(0, -1)

  if (truncateAfterNum && newName.length > truncateAfterNum) {
    newName = newName.slice(0, truncateAfterNum)
    newName = newName + "..."
  }

  return newName
}

export const abbrevDST = (name) => {
  if (!name) return name
  const nameParts = name.split(" ")
  
  if (nameParts.length <= 1) return name
  return nameParts[nameParts.length - 1]
}